module.exports = __webpack_public_path__ + "media/assets/images/tour/1_Tour_3-54bd4a4f51235bff15a5928f7beb917f.png";